// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-calendar-picker-input.ant-input{border-radius:30px}`, "",{"version":3,"sources":["webpack://./user/src/components/DatePicker/AntDatePicker/custom-ant.css"],"names":[],"mappings":"AADA,qCAAA,kBAAA","sourcesContent":[".ant-calendar-picker-input.ant-input {\n  border-radius: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
